import React from 'react';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Badge from 'components/generic/Badge.component';
import Icon from 'components/generic/Icon.component';
import CurrencySign from 'components/price/CurrencySign.component';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import ConfirmationModal from 'common/ConfirmationModal';

import CN from './VoucherItem.module.scss';

const VoucherItem = (props) => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const { val: renderDropdown, tip: toggleHidden } = useTip(true);
  const { val: isVoucherDeleted, yay: showModal, nay: hideModal } = useTip(false);

  const toggleDropdown = () => void toggleHidden();

  const handleDelete = () => void showModal();

  const cancelDelete = () => void hideModal();

  const onConfirmDelete = () => {
    props.onDeleteHandler(props.id);
    hideModal();
  };

  const VOUCHER_STATUS = Object.freeze({
    expired: <Badge name={t('composite.badge.expired')} variant="warning" />,
    valid: <Badge name={t('composite.badge.valid')} variant="success" />,
    used: <Badge name={t('composite.badge.used')} variant="draft" />,
  });

  const renderVaucherStatus = () => VOUCHER_STATUS[props.state] || t('composite.badge.used');

  const componentClasses = cn({
    [CN.component]: true,
    [CN.active]: !renderDropdown,
    [CN.darkMode]: isDarkMode,
  });

  return (
    <div data-bem="VoucherItem" className={componentClasses}>
      {isVoucherDeleted && (
        <ConfirmationModal
          popupTitle={t('voucherTracking.voucherItem.confirmationModal.title')}
          popupMessage={t('voucherTracking.voucherItem.confirmationModal.description')}
          leftButtonText={t('common.buttons.no')}
          rightButtonText={t('common.buttons.yes')}
          leftButtonCallback={cancelDelete}
          rightButtonCallback={onConfirmDelete}
        />
      )}
      <div>
        <div className={CN.headerContainer}>
          <div className={CN.cell1}>{props.created}</div>
          <div className={CN.cell2}>{props.number}</div>
          <div className={CN.cell3}>
            <CurrencySign value={props.amount} />
          </div>
          <div className={CN.cell4}>{props.purchased}</div>
          <div className={CN.cell5}>{props.paymentType} </div>
          <div className={CN.cell6}>
            <div className={CN.statusContainer}>{renderVaucherStatus()}</div>
          </div>
          <div className={CN.cell7}>{props.expires}</div>
          <div className={CN.cell8}>
            <Button variant="outline" width="small" onClick={toggleDropdown}>
              <div className={CN.buttonText}>
                {renderDropdown
                  ? t('voucherTracking.voucherItem.showDetailsButton')
                  : t('voucherTracking.voucherItem.hideDetailsButton')}
              </div>
            </Button>
          </div>
        </div>

        {!renderDropdown && (
          <div>
            {!props.hideDeleteButton && (
              <div className={CN.deleteVoucherContainer}>
                <Button variant="warning" width="small" onClick={handleDelete}>
                  <Icon variant="delete" width="md" />
                  <span className={CN.textSize}>{t('voucherTracking.voucherItem.deleteButton')}</span>
                </Button>
              </div>
            )}
            {props.children}
          </div>
        )}
      </div>
    </div>
  );
};

export default VoucherItem;
